<template>
    <div class="file-list__item-inner">
        <a :href="file.url" class="file-list__link">{{file.title}}</a>

        <div class="file-list__item-control">
            <custom-button @click="remove(file.id)" iconic><span icon remove></span>Odebrat</custom-button>
        </div>
    </div>
</template>

<script>
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'FileItem',
    components: { CustomButton },
    props:      {
        file: {
            type:     Object,
            required: true,
        }
    },
    methods:    {
        remove(fileId) {
            this.$modal.show('dialog', {
                text:    'Opravdu chcete soubor <strong>' + this.file.title + '</strong> odpojit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odpojit',
                        handler: () => {
                            this.$emit('remove', fileId);
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        }
    }
}
</script>
